module.exports = __webpack_public_path__ + "img/clear.ef9eca20.svg";